import React, { useEffect, useState } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import Swal from "sweetalert2";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { formatCNPJ } from "../../Services/formatCNPJ";

export default function VincularProcessoUsuarios() {
  const [clientes, setClientes] = useState([]);
  const [processos, setProcessos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [processoSelecionado, setProcessoSelecionado] = useState(null);
  const [usuariosSelecionados, setUsuariosSelecionados] = useState([]);

  const [filtroClientes, setFiltroClientes] = useState("");
  const [filtroProcessos, setFiltroProcessos] = useState("");
  const [filtroUsuarios, setFiltroUsuarios] = useState("");

  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador } = useOperador();
  const navigate = useNavigate();
  let idFormatado = String(IDOperador).padStart(6, "0");

  // Proteção de rota
  useEffect(() => {
    if (!operador && !authReady) navigate("/");
  }, [operador]);

  useEffect(() => {
    carregarClientes();
    carregarUsuarios();
  }, []);

  const carregarClientes = async () => {
    try {
      const res = await api.get("/clientes");
      setClientes(res.data);
    } catch (err) {
      console.error("Erro ao carregar clientes", err);
    }
  };

  const carregarUsuarios = async () => {
    try {
      const res = await api.get("/operadores");
      setUsuarios(res.data);
    } catch (err) {
      console.error("Erro ao carregar usuários", err);
    }
  };

  const carregarProcessos = async (idcliente) => {
    try {
      const res = await api.get(`/processo/cliente/${idcliente}`);
      setProcessos(res.data);
    } catch (err) {
      console.error("Erro ao carregar processos", err);
    }
  };

  // Quando muda o cliente → reinicia o fluxo
  useEffect(() => {
    setProcessoSelecionado(null);
    setUsuariosSelecionados([]);
    if (clienteSelecionado) carregarProcessos(clienteSelecionado);
    else setProcessos([]);
  }, [clienteSelecionado]);

  // Filtragens
  const clientesFiltrados = clientes.filter((c) =>
    `${c.nome} - ${formatCNPJ(c.cnpj)}`
      .toLowerCase()
      .includes(filtroClientes.toLowerCase())
  );

  const processosFiltrados = processos.filter((p) =>
    p.descricao.toLowerCase().includes(filtroProcessos.toLowerCase())
  );

  const usuariosFiltrados = usuarios.filter((u) =>
    `${String(u.IDOperador).padStart(6, "0")} - ${u.nome}`
      .toLowerCase()
      .includes(filtroUsuarios.toLowerCase())
  );

  const handleUsuarioChange = (idUsuario) => {
    setUsuariosSelecionados((prev) =>
      prev.includes(idUsuario)
        ? prev.filter((id) => id !== idUsuario)
        : [...prev, idUsuario]
    );
  };

  // SALVAR – Apenas insere, nunca deleta
  const handleSalvar = async () => {
    if (!clienteSelecionado) {
      Swal.fire("Atenção", "Selecione um cliente.", "info");
      return;
    }
    if (!processoSelecionado) {
      Swal.fire("Atenção", "Selecione um processo.", "info");
      return;
    }
    if (usuariosSelecionados.length === 0) {
      Swal.fire("Atenção", "Selecione ao menos um usuário.", "info");
      return;
    }

    try {
      let inseridos = 0;
      let ignorados = 0;

      for (const idUsuario of usuariosSelecionados) {
        // verificar se já existe vinculo
        const res = await api.get(
          `/processo/operadorcliente/verificavinculo/${idUsuario}/${processoSelecionado}`
        );

        const existe = Array.isArray(res.data) && res.data.length > 0;

        if (!existe) {
          await api.post("/processo/operador", {
            IDOperador: idUsuario,
            IDProcesso: processoSelecionado,
          });
          inseridos++;
        } else {
          ignorados++;
        }
      }

      Swal.fire(
        "Sucesso!",
        `Vínculos criados: ${inseridos}\nJá existiam: ${ignorados}`,
        "success"
      );

      setUsuariosSelecionados([]);

    } catch (err) {
      console.error("Erro ao salvar vinculação", err);
      Swal.fire("Erro", "Falha ao salvar vinculação.", "error");
    }
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior userId={idFormatado} userName={nome} />

        <div className="container">
          <h2>Vincular Processo a Usuários</h2>

          <div className="grid">
            {/* COLUNA 1 - CLIENTES */}
            <div className="column">
              <h3>Clientes</h3>

              {clientes.length > 0 && (
                <input
                  type="text"
                  placeholder="Filtrar clientes..."
                  value={filtroClientes}
                  onChange={(e) => setFiltroClientes(e.target.value)}
                  className={`input-filtro ${
                    clientesFiltrados.length > 0 ? "show" : ""
                  }`}
                />
              )}

              <ul>
                {clientesFiltrados.map((c) => (
                  <li
                    key={c.IDCliente}
                    className={
                      clienteSelecionado === c.IDCliente ? "itemSelecionado" : ""
                    }
                  >
                    <label>
                      <input
                        type="radio"
                        name="cliente"
                        checked={clienteSelecionado === c.IDCliente}
                        onChange={() => setClienteSelecionado(c.IDCliente)}
                      />
                      {c.nome + " - " + formatCNPJ(c.cnpj)}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            {/* COLUNA 2 - PROCESSOS */}
            <div className="column">
              <h3>Processos</h3>

              {processos.length > 0 && (
                <input
                  type="text"
                  placeholder="Filtrar processos..."
                  value={filtroProcessos}
                  onChange={(e) => setFiltroProcessos(e.target.value)}
                  className={`input-filtro ${
                    processosFiltrados.length > 0 ? "show" : ""
                  }`}
                />
              )}

              <ul>
                {processosFiltrados.map((p) => (
                  <li
                    key={p.IDProcesso}
                    className={
                      processoSelecionado === p.IDProcesso
                        ? "itemSelecionado"
                        : ""
                    }
                  >
                    <label>
                      <input
                        type="radio"
                        name="processo"
                        checked={processoSelecionado === p.IDProcesso}
                        onChange={() => setProcessoSelecionado(p.IDProcesso)}
                      />
                      {p.descricao}
                    </label>
                  </li>
                ))}
              </ul>
            </div>

            {/* COLUNA 3 - USUÁRIOS */}
            <div className="column">
              <h3>Usuários</h3>

              {usuarios.length > 0 && (
                <input
                  type="text"
                  placeholder="Filtrar usuários..."
                  value={filtroUsuarios}
                  onChange={(e) => setFiltroUsuarios(e.target.value)}
                  className={`input-filtro ${
                    usuariosFiltrados.length > 0 ? "show" : ""
                  }`}
                />
              )}

              <ul>
                {usuariosFiltrados.map((u) => (
                  <li key={u.IDOperador}>
                    <label>
                      <input
                        type="checkbox"
                        checked={usuariosSelecionados.includes(u.IDOperador)}
                        onChange={() => handleUsuarioChange(u.IDOperador)}
                      />
                      {String(u.IDOperador).padStart(6, "0") + " - " + u.nome}
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <button onClick={handleSalvar} className="btn-salvar">
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}
